import { MediaAssetTypesEnum as MediaAssetTypes } from "__gen__/appService";

export default MediaAssetTypes;
